import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Button = styled.button<{ $selected: boolean; $large?: boolean }>`
  display: block;

  padding: ${({ theme }) => theme.spacing(1.5)};
  margin: 0;

  border-radius: ${({ theme }) => theme.spacing(2.5)};
  border: 1px solid
    ${({ theme, $selected }) =>
      $selected ? theme.palette.primary.main : theme.palette.divider};
  background: ${({ theme }) => theme.palette.background.default};
  cursor: pointer;
  transition: border-color 200ms;

  font-size: 2rem;
  line-height: 62.5%;

  color: ${({ theme }) => theme.palette.text.primary};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: ${({ theme }) => theme.spacing(3)};
      font-size: 2.4rem;
    `};

  ${({ $large }) =>
    $large &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;

      width: 4rem;
      height: 4rem;
      padding: 0;

      font-size: 2.25rem;
    `};
`;

export const PremiumLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  display: block;

  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(2)}`};

  background: ${({ theme }) => theme.palette.info.light};
  border-radius: ${({ theme }) => theme.spacing(6)};

  color: ${({ theme }) => theme.palette.info.main};
`;

export const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: ${({ theme }) => theme.spacing(2)};
  list-style: none;

  margin: 0;
  padding: ${({ theme }) => theme.spacing(2)};
`;
